import React from 'react';
import { motion } from 'framer-motion';
import { Plus, Check, Sparkles } from 'lucide-react';
function IncludeItem({
  children,
  bold
}: {
  children: React.ReactNode;
  bold?: boolean;
}) {
  return <li className="flex items-start gap-3" data-id="element-105">
      <Plus className="text-brand-600 shrink-0 mt-0.5" size={18} data-id="element-106" />
      <span className={bold ? 'text-gray-900 font-medium' : 'text-gray-700'} data-id="element-107">
        {children}
      </span>
    </li>;
}
export function PricingSection() {
  return <section className="py-24 px-6 bg-gray-50" data-id="element-108">
      <div className="max-w-6xl mx-auto" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-110">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-gray-900 mb-4" data-id="element-111">
            Planes transparentes
          </h2>
          <p className="text-lg text-gray-500 max-w-2xl mx-auto" data-id="element-112">
            Elige si quieres hacerlo todo tú… o dejar de perder tiempo con leads
            que no sirven
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch" data-id="element-113">
          {/* Plan Start */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0
        }} className="bg-white rounded-3xl p-8 border border-gray-200 shadow-sm flex flex-col" data-id="element-114">
            <div className="mb-6" data-id="element-115">
              <p className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-1" data-id="element-116">
                Plan Start
              </p>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-117">
                Aprende a vender bien
              </h3>
              <div className="flex items-baseline gap-1 mb-3" data-id="element-118">
                <span className="text-4xl font-extrabold tracking-tight text-gray-900" data-id="element-119">
                  $129.900
                </span>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-120">
                Para quienes quieren vender solos, pero sin cometer errores
                básicos
              </p>
            </div>

            <ul className="space-y-3 mb-8 text-sm flex-1" data-id="element-121">
              <IncludeItem data-id="element-122">Curso guiado (5 videos paso a paso)</IncludeItem>
              <IncludeItem data-id="element-123">
                1 sesión estratégica de 60 min enfocada en tu propiedad
              </IncludeItem>
              <IncludeItem data-id="element-124">Checklist y guías del proceso de venta</IncludeItem>
              <IncludeItem data-id="element-125">
                Base clara para definir precio, publicación y estrategia
              </IncludeItem>
            </ul>

            <button className="w-full py-3 px-6 rounded-xl font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 transition-colors text-sm mt-auto" data-id="element-126">
              Elegir Plan Start
            </button>
          </motion.div>

          {/* Plan Base */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white rounded-3xl p-8 border border-gray-200 shadow-sm flex flex-col" data-id="element-127">
            <div className="mb-6" data-id="element-128">
              <p className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-1" data-id="element-129">
                Plan Base
              </p>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-130">
                Publica mejor y ordénate
              </h3>
              <div className="flex items-baseline gap-1 mb-3" data-id="element-131">
                <span className="text-4xl font-extrabold tracking-tight text-gray-900" data-id="element-132">
                  $349.900
                </span>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-133">
                Para quienes quieren vender solos, pero con mejor exposición y
                estructura
              </p>
            </div>

            <ul className="space-y-3 mb-4 text-sm flex-1" data-id="element-134">
              <IncludeItem bold data-id="element-135">Todo lo del Plan Start</IncludeItem>
              <IncludeItem data-id="element-136">
                Revisión y optimización de tu publicación (1 vez)
              </IncludeItem>
              <IncludeItem data-id="element-137">
                Publicación en Portal Inmobiliario desde nuestra cuenta
              </IncludeItem>
              <IncludeItem data-id="element-138">
                1 sesión de seguimiento de 60 min para resolver dudas
                específicas de tu propiedad
              </IncludeItem>
              <IncludeItem data-id="element-139">
                Te damos feedback directo sobre tu caso, no solo teoría
              </IncludeItem>
              <IncludeItem data-id="element-140">
                Acceso a CRM simple para gestionar contactos
              </IncludeItem>
              <IncludeItem data-id="element-141">Templates de respuesta a interesados</IncludeItem>
            </ul>

            <p className="text-xs text-brand-700 bg-brand-50 rounded-lg px-3 py-2 mb-8" data-id="element-142">
              Publicar desde nuestra cuenta mejora la visibilidad y reduce el
              ruido de contactos irrelevantes
            </p>

            <button className="w-full py-3 px-6 rounded-xl font-medium text-brand-700 bg-brand-50 hover:bg-brand-100 transition-colors text-sm mt-auto" data-id="element-143">
              Elegir Plan Base
            </button>
          </motion.div>

          {/* Plan Pro */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white rounded-3xl p-8 border-2 border-brand-600 shadow-xl relative flex flex-col" data-id="element-144">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand-600 text-white px-4 py-1 rounded-full text-sm font-bold flex items-center gap-1.5 shadow-sm whitespace-nowrap" data-id="element-145">
              <Sparkles size={14} data-id="element-146" />
              Más elegido
            </div>

            <div className="mb-6" data-id="element-147">
              <p className="text-sm font-semibold text-brand-600 uppercase tracking-wider mb-1" data-id="element-148">
                Plan Pro
              </p>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-149">
                Vende mejor, sin perder tiempo
              </h3>
              <div className="flex items-baseline gap-1 mb-3" data-id="element-150">
                <span className="text-4xl font-extrabold tracking-tight text-gray-900" data-id="element-151">
                  $899.900
                </span>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-152">
                Para quienes quieren vender sin perder tiempo con compradores
                que no sirven
              </p>
            </div>

            <ul className="space-y-3 mb-8 text-sm flex-1" data-id="element-153">
              <li className="flex items-start gap-3 bg-brand-50 rounded-lg px-3 py-2 -mx-1" data-id="element-154">
                <Plus className="text-brand-600 shrink-0 mt-0.5" size={18} data-id="element-155" />
                <span className="text-brand-800 font-semibold text-sm" data-id="element-156">
                  Recibimos y filtramos todos tus contactos antes de que hables
                  con ellos
                </span>
              </li>
              <IncludeItem bold data-id="element-157">Todo lo del Plan Base</IncludeItem>
              <IncludeItem data-id="element-158">Fotos profesionales</IncludeItem>
              <IncludeItem data-id="element-159">Plano de la propiedad</IncludeItem>
              <IncludeItem data-id="element-160">
                Publicación destacada en Portal Inmobiliario
              </IncludeItem>
              <IncludeItem data-id="element-161">Atención inicial de todos los leads</IncludeItem>
              <IncludeItem data-id="element-162">Filtrado de compradores reales</IncludeItem>
              <IncludeItem data-id="element-163">Coordinación de visitas</IncludeItem>
              <IncludeItem data-id="element-164">Asesoría en ofertas y negociación</IncludeItem>
              <IncludeItem data-id="element-165">Apoyo en promesa y notaría</IncludeItem>
            </ul>

            <button className="w-full py-3.5 px-6 rounded-xl font-medium text-white bg-brand-600 hover:bg-brand-700 transition-colors shadow-sm hover:shadow-md text-sm mt-auto" data-id="element-166">
              Empezar con Plan Pro
            </button>
          </motion.div>
        </div>

        {/* Global note */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center text-sm text-gray-400 mt-10 max-w-xl mx-auto" data-id="element-167">
          Nosotros no actuamos como corredores ni intermediamos la venta. Tú
          mantienes el control total en todo momento.
        </motion.p>
      </div>
    </section>;
}